import axios from 'axios';
//axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;

// Configuración base de Axios
const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  withCredentials: true, // ⚠️ importante si usás cookies de sesión

});


// Configuración del token global
instance.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

// Manejo global de respuestas y errores
instance.interceptors.response.use(
  response => response,
  error => {
    const { response, config } = error;
    const isLogin = config?.headers['X-Is-Login'] === 'true';

    if (response && !isLogin) {
      switch (response.status) {
        case 401:
          alert('Tu sesión ha expirado. Por favor inicia sesión nuevamente.');
          localStorage.removeItem('token');
          window.location.href = '/login';
          break;
        case 402:
          alert('Su suscripción ha expirado o no es válida. Por favor, renueve su suscripción.');
          localStorage.removeItem('token');
          window.location.href = '/login';
          break;
        case 403:
          alert('No tienes permisos suficientes para esta acción.');
          break;
        case 405:
          alert('Usuario inhabilitado.');
          localStorage.removeItem('token');
          window.location.href = '/login';
          break;
        case 404:
          alert('Recurso no encontrado.');
          break;
      }
    } else if (!response && !isLogin) {
      alert('No se pudo conectar con el servidor.');
      localStorage.removeItem('token');
      window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);


export default instance;
